import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d172902"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line" }
const _hoisted_2 = { class: "hide-mobile" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "product-name" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "comment" }
const _hoisted_7 = { class: "hide-desktop mobile-amount" }
const _hoisted_8 = { class: "hide-mobile" }
const _hoisted_9 = { class: "amount hide-mobile" }
const _hoisted_10 = { class: "no-wrap" }
const _hoisted_11 = { class: "price-per" }
const _hoisted_12 = {
  key: 0,
  class: "scan-btns hide-mobile"
}
const _hoisted_13 = { class: "wrapper" }
const _hoisted_14 = { class: "checkmark" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark__circle" }, null, -1))
const _hoisted_16 = { class: "checkmark__check" }
const _hoisted_17 = { class: "scan-decrement" }
const _hoisted_18 = {
  key: 1,
  class: "scan-btns hide-mobile"
}
const _hoisted_19 = { class: "container-kg" }
const _hoisted_20 = ["checked"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkmark-kg" }, null, -1))
const _hoisted_22 = { class: "max-content" }
const _hoisted_23 = { class: "max-content hide-mobile" }
const _hoisted_24 = { class: "orderline-edit-modal" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Rediger ordrelinje", -1))
const _hoisted_26 = { class: "field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Varenr", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Varenavn", -1))
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "field" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Antall", -1))
const _hoisted_34 = { class: "field-error" }
const _hoisted_35 = { class: "field" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Rabatt (%)", -1))
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "field" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Pris", -1))
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "field-error" }
const _hoisted_42 = { class: "field" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Kommentar", -1))
const _hoisted_44 = { class: "field-error" }
const _hoisted_45 = { class: "action-buttons" }
const _hoisted_46 = { class: "image-modal" }
const _hoisted_47 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ValidationFormErrors = _resolveComponent("ValidationFormErrors")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_TextButton = _resolveComponent("TextButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", _hoisted_1, [
      _createElementVNode("td", _hoisted_2, [
        _createElementVNode("p", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showImage && _ctx.showImage(...args))),
          class: _normalizeClass(["product-image-link", {
          'has-image': _ctx.orderline.product.main_image?.url,
        }]),
          href: _ctx.productLink,
          target: "_blank"
        }, _toDisplayString(_ctx.orderline.product.id), 11, _hoisted_3)
      ]),
      _createElementVNode("td", _hoisted_4, [
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            class: "product-link",
            href: _ctx.productLink,
            target: "_blank"
          }, _toDisplayString(_ctx.orderline.product.name), 9, _hoisted_5),
          (_ctx.orderline.should_ship)
            ? (_openBlock(), _createBlock(_component_SvgIcon, {
                key: 0,
                class: "shipping-icon",
                type: "mdi",
                path: _ctx.shippingIcon
              }, null, 8, ["path"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.orderline.comment), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.orderline.amount) + " " + _toDisplayString(_ctx.orderline.product.unit), 1),
        (_ctx.discount !== 0)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["discount hide-desktop", {
          overcharge: _ctx.orderline.product.price < _ctx.orderline.price_out,
        }])
            }, _toDisplayString(_ctx.discount > 0 ? "+" : "") + _toDisplayString(_ctx.discount) + "% ", 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_8, [
        _createElementVNode("p", null, _toDisplayString(_ctx.toCurrency(_ctx.orderline.price_out_with_mva)), 1),
        (_ctx.discount !== 0)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["discount", {
          overcharge: _ctx.orderline.product.price < _ctx.orderline.price_out,
        }])
            }, _toDisplayString(_ctx.discount > 0 ? "+" : "") + _toDisplayString(_ctx.discount) + "% ", 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_9, [
        (!_ctx.closed && !_ctx.isWeborder)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              disabled: !_ctx.orderlineIsEditable,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeAmount(-1))),
              class: "amount-button",
              color: "white"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SvgIcon, {
                  type: "mdi",
                  path: _ctx.minusIcon
                }, null, 8, ["path"])
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.editForm.amount.toLocaleString("nb")) + " " + _toDisplayString(_ctx.orderline.product.unit), 1),
        (!_ctx.closed && !_ctx.isWeborder)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              disabled: !_ctx.orderlineIsEditable,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeAmount(1))),
              class: "amount-button",
              color: "white"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SvgIcon, {
                  type: "mdi",
                  path: _ctx.plusIcon
                }, null, 8, ["path"])
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.toCurrency(_ctx.totalPrice)), 1),
      (
        _ctx.isWeborder &&
        _ctx.orderline.product.unit !== 'FRAKT' &&
        _ctx.orderline.product.unit !== 'kg'
      )
        ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass({
          scanned: _ctx.orderline.scanned_count === _ctx.orderline.amount,
          'not-scanned': _ctx.orderline.scanned_count === 0,
          'not-finished-scanned':
            _ctx.orderline.scanned_count > 0 &&
            _ctx.orderline.scanned_count < _ctx.orderline.amount,
        })
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.orderline.scanned_count), 1)
                ])
              ])
            ], 2),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_SvgIcon, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.unscanProduct(_ctx.orderline.product?.barcode))),
                class: _normalizeClass(["minus-circle-icon", { 'disabled-icon': _ctx.orderline.scanned_count === 0 }]),
                size: "40",
                type: "mdi",
                path: _ctx.minusCircle
              }, null, 8, ["class", "path"])
            ])
          ]))
        : (_ctx.isWeborder && _ctx.orderline.product.unit === 'kg')
          ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, [
                _createElementVNode("input", {
                  onChange: _cache[4] || (_cache[4] = (e) => _ctx.toggleCheckKgOrder(e, _ctx.orderline.product.id)),
                  checked: _ctx.orderline.scanned_count !== 0,
                  type: "checkbox"
                }, null, 40, _hoisted_20),
                _hoisted_21
              ])
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("td", _hoisted_22, [
        (!_ctx.closed && !_ctx.isWeborder)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              disabled: !_ctx.orderlineIsEditable,
              color: "white",
              onClick: _ctx.openEditModal
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SvgIcon, {
                  type: "mdi",
                  path: _ctx.editIcon
                }, null, 8, ["path"])
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.closed && !_ctx.isWeborder)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              "aria-label": "Slett ordrelinje",
              disabled: !_ctx.orderlineIsEditable,
              color: "red",
              class: "orderline-delete-button hide-desktop",
              onClick: _ctx.destroyOrderline
            }, {
              default: _withCtx(() => [
                (!_ctx.destroyLoading)
                  ? (_openBlock(), _createBlock(_component_SvgIcon, {
                      key: 0,
                      type: "mdi",
                      path: _ctx.deleteIcon
                    }, null, 8, ["path"]))
                  : (_openBlock(), _createBlock(_component_SvgIcon, {
                      key: 1,
                      class: "animate-spin",
                      type: "mdi",
                      path: _ctx.loadingIcon
                    }, null, 8, ["path"]))
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_23, [
        (!_ctx.closed && !_ctx.isWeborder)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              "aria-label": "Slett ordrelinje",
              disabled: !_ctx.orderlineIsEditable,
              color: "red",
              class: "orderline-delete-button",
              onClick: _ctx.destroyOrderline
            }, {
              default: _withCtx(() => [
                (!_ctx.destroyLoading)
                  ? (_openBlock(), _createBlock(_component_SvgIcon, {
                      key: 0,
                      type: "mdi",
                      path: _ctx.deleteIcon
                    }, null, 8, ["path"]))
                  : (_openBlock(), _createBlock(_component_SvgIcon, {
                      key: 1,
                      class: "animate-spin",
                      type: "mdi",
                      path: _ctx.loadingIcon
                    }, null, 8, ["path"]))
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showEditModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          "with-card": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_ValidationFormErrors, {
                errors: _ctx.editForm.errors
              }, null, 8, ["errors"]),
              _createElementVNode("header", null, [
                _hoisted_25,
                _createVNode(_component_SvgIcon, {
                  class: "closeIcon",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showEditModal = false)),
                  type: "mdi",
                  path: _ctx.closeIcon
                }, null, 8, ["path"])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("input", {
                  class: "input",
                  type: "text",
                  disabled: "",
                  value: _ctx.orderline.product.id
                }, null, 8, _hoisted_28)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("input", {
                  class: "input",
                  type: "text",
                  value: _ctx.orderline.product.name,
                  disabled: ""
                }, null, 8, _hoisted_31)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.selectText && _ctx.selectText(...args))),
                  type: "number",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editForm.amount) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.editForm.amount]
                ]),
                _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.editForm.errors.amount), 1)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("input", {
                  onFocus: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.selectText && _ctx.selectText(...args))),
                  type: "number",
                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.setEditRebate && _ctx.setEditRebate(...args))),
                  value: _ctx.editRebate
                }, null, 40, _hoisted_37)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("input", {
                  onFocus: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.selectText && _ctx.selectText(...args))),
                  type: "number",
                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.setPriceOutWithMva && _ctx.setPriceOutWithMva(...args))),
                  value: _ctx.priceOutWithMva
                }, null, 40, _hoisted_40),
                _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.editForm.errors.price_out), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editForm.comment) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.editForm.comment]
                ]),
                _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.editForm.errors.comment), 1)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_Button, {
                  onClick: _ctx.sendEditForm,
                  color: "green",
                  "aria-label": "Lagre endringer i ordrelinje"
                }, {
                  default: _withCtx(() => [
                    (_ctx.editForm.processing)
                      ? (_openBlock(), _createBlock(_component_SvgIcon, {
                          key: 0,
                          class: "animate-spin",
                          type: "mdi",
                          path: _ctx.loadingIcon
                        }, null, 8, ["path"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" Lagre ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  onClick: _ctx.abortEdit,
                  color: "gray"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Avbryt")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showProductImageModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          "with-card": true,
          onDismiss: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showProductImageModal = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_TextButton, {
                class: "image-modal__close",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showProductImageModal = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SvgIcon, {
                    type: "mdi",
                    path: _ctx.closeIcon
                  }, null, 8, ["path"])
                ]),
                _: 1
              }),
              _createElementVNode("img", {
                class: "image-modal__image",
                src: _ctx.orderline.product.main_image?.url,
                alt: "Produktbilde"
              }, null, 8, _hoisted_47)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}